.title {
    font-weight: normal;
    margin-bottom: var(--mantine-spacing-md);
    margin-left: var(--mantine-spacing-md);
    min-height: 20px;
    width: 100%;

    @container (min-width: $mantine-breakpoint-sm) {
        font-weight: normal;
        margin-bottom: var(--mantine-spacing-md);
        margin-left: var(--mantine-spacing-md);
        min-height: 50px;
    }
}

.text {
    color: var(--mantine-color-dark-9);
    font-size: var(--mantine-font-size-xl);
    @container (min-width: $mantine-breakpoint-sm) {
        font-size: 32px;
    }
}

.kai {
    border-radius: var(--mantine-radius-md);
    background-color: var(--kai-brand-base);
    color: var(--kai-brand-accent);
    padding: 4px 7px;
    font-size: var(--mantine-font-size-lg);
    font-weight: normal;

    @container (min-width: $mantine-breakpoint-sm) {
        font-size: 26px;
    }
}

.cursor {
    margin-top: 0px;
    margin-left: 1px;
    align-self: center;
    border-right: 2px solid var(--mantine-color-dark-3);
    border-radius: 0;
    height: var(--mantine-spacing-lg);
    width: 2px;

    @container (min-width: $mantine-breakpoint-sm) {
        border-right: 2px solid var(--mantine-color-dark-3);
        margin-top: 4px;
        margin-left: 2px;
        height: var(--mantine-spacing-xl);
    }
}

.blink {
    animation: blink 1000ms step-end infinite;
}

@keyframes blink {
    50% {
        opacity: 0;
    }
}
